import { ClipLoader } from "react-spinners";

export default function LoadingPop() {
    return (
        <div className="fixed inset-0 w-full h-full flex justify-center items-center z-[400]">
            <ClipLoader color="#FF8542" size={100} />
        </div>
    );
}
